export default "__VITE_ASSET__5fb98b10__"